import React from "react";
import Modal from "@mui/material/Modal";
import { RxCross1 } from "react-icons/rx";
import { TbAlertHexagonFilled } from "react-icons/tb";

function SapAnalysisArchiveModal({ open, HandleClose, HandleArchive, message }) {
  return (
    <Modal
      open={open}
      onClose={() => HandleClose()}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <div className="modal_block">
        <div className="modal_header">
          <div className="modal_title_wrapper">
            <h2 className="modal_title">Are you Sure ?</h2>
          </div>
          <div className="cancel-btn-wrap">
            <RxCross1 onClick={() => HandleClose()} />
          </div>
        </div>
        <div className="modal_content">
          <div className="modal_content_inner">
            <div>
              <TbAlertHexagonFilled />
            </div>
            <div>
              <p>{message || "Are you sure you want to archive this record?"}</p>
            </div>
          </div>
        </div>
        <div className="modal_footer">
          <button onClick={() => HandleClose()} className="btn btn-border">
            Cancel
          </button>
          <button onClick={() => HandleArchive()} className="btn btn-primary" style={{ backgroundColor: "#00A272", borderColor: "#00A272" }}>
            Archive
          </button>
        </div>
      </div>
    </Modal>
  );
}

export default SapAnalysisArchiveModal;
